import { net_filemanage } from "@/api/http";

export const API_STFMFM02C08_FilePreviewDisplay = (...params) =>
net_filemanage.post("/api/STFMFM02C08/FilePreviewDisplay", ...params);

export const API_STFMFM02C08_UpdateTradingInfo = (...params) =>
net_filemanage.post("/api/STFMFM02C08/UpdateTradingInfo", ...params);

export const API_STFMFM02C08_TempFileToPDF= (...params) =>
net_filemanage.post("/api/STFMFM02C08/TempFileToPDF", ...params);

export const API_STFMFM02C08_UnlockFile = (...params) =>
net_filemanage.post("/api/STFMFM02C08/UnlockFile", ...params);

// No4スキャナ保存対応
// export const API_STFMFM02C08_RequirementCheck = (...params) =>
// net_filemanage.post("/api/STFMFM02C08/RequirementCheck", ...params);